import BlogEditContainer from "../../../../Component/Application/blogs/AddSeo/SeoCreate";

const SeoAddEdit = () => {
  return (
    <div className="page-body">
      <BlogEditContainer />
    </div>
  );
};

export default SeoAddEdit;
